import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-auto bg-slate-900 text-white py-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap gap-4 items-center justify-between text-sm">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 text-slate-200">
            <span>Тел: <a href="tel:88002505710" className="text-white hover:text-secondary-light transition-colors">8 800 250 57 10</a></span>
            <span>Email: <a href="mailto:info@teplogrand.pro" className="text-white hover:text-secondary-light transition-colors">info@teplogrand.pro</a></span>
          </div>
          <div className="text-slate-400">
            © 2025 Теплогранд. Все права защищены
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 